import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {FormsSearch} from '../../models/forms-search.interface';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-forms-filter',
  templateUrl: './forms-filter.component.html',
  styleUrls: ['./forms-filter.component.scss']
})
export class FormsFilterComponent implements OnInit {

  searchForm = this.formBuilder.group({
    startYear: [''],
    endYear: [''],
    form: [''],
    startLaunched: [''],
    endLaunched: [''],
    minQuestions: [''],
    maxQuestions: [''],
    status: []
  });

  get startYearControl(): FormControl {
    return this.searchForm.get('startYear') as FormControl;
  }
  get endYearControl(): FormControl {
    return this.searchForm.get('endYear') as FormControl;
  }
  get formControl(): FormControl {
    return this.searchForm.get('form') as FormControl;
  }
  get startLaunchedControl(): FormControl {
    return this.searchForm.get('startLaunched') as FormControl;
  }
  get endLaunchedControl(): FormControl {
    return this.searchForm.get('endLaunched') as FormControl;
  }
  get minQuestionsControl(): FormControl {
    return this.searchForm.get('minQuestions') as FormControl;
  }
  get maxQuestionsControl(): FormControl {
    return this.searchForm.get('maxQuestions') as FormControl;
  }
  get statusControl(): FormControl {
    return this.searchForm.get('status') as FormControl;
  }

  @Output()
  search: EventEmitter<FormsSearch> = new EventEmitter<FormsSearch>();

  constructor(private formBuilder: FormBuilder,
              private datePipe: DatePipe) { }

  ngOnInit(): void {
  }

  handleSubmit(): void {
    const dto: FormsSearch = {
      startYear: this.startYearControl.value,
      endYear: this.endYearControl.value,
      form: this.formControl.value,
      startLaunched: this.datePipe.transform(this.startLaunchedControl.value, 'yyyy-MM-dd HH:mm:ss'),
      endLaunched: this.datePipe.transform(this.endLaunchedControl.value, 'yyyy-MM-dd HH:mm:ss'),
      minQuestions: this.minQuestionsControl.value,
      maxQuestions: this.maxQuestionsControl.value,
      status: this.statusControl.value
    };
    this.search.emit(dto);
  }

  clean(): void {
    this.search.emit({});
  }

}
